import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../reusable-components/InputField';
import CheckboxField from '../../../../reusable-components/CheckboxField';
import PageContent from '../../../../reusable-components/ActivatePageContent';
import PageHeader from '../../../../reusable-components/ActivatePageHeader';
import { required, email, compare_email, checked } from '../../../../utils/validations';
import Header from '../../../../reusable-components/Header';
import Footer from '../../../../reusable-components/Footer';
import Body from '../../../../reusable-components/Body';
import ModalComponent from '../../../../reusable-components/Modal';
import Spinner from '../../../../reusable-components/Spinner'; 
import PropTypes from 'prop-types';

class StepTwoForm extends Component {
  constructor(props){
    super(props);
    this.state = {
      show: false,
      user_id: localStorage.getItem('user_id')
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.openModal = this.openModal.bind(this);
    this.openVideo = this.openVideo.bind(this);
  }

  onSubmit(values){
    const { updateUser, history } = this.props;
    let user_id = localStorage.getItem('user_id');
    values.customer_id = user_id;
    updateUser(values, history);
  }

  openVideo() {
    this.setState({ video: true });
  }

  openModal() {
    this.setState({ show: true });
  }

  componentDidMount() {
    const { fetchUser, history } = this.props;
    const { user_id } = this.state;
    if (user_id !== 'undefined' && user_id !== null) {
      fetchUser(user_id);
    }
  }

  render() {
    const { handleSubmit, pristine, submitting, isloading, formErrors, initialValues } = this.props;
    let buttonState = null;

    buttonState = isloading ? <Spinner /> : "Doorgaan";

    return (
      <React.Fragment>
        <PageHeader title="Bevestig informatie" />
        <PageContent 
          title="Persoonlijke informatie"
          goBack={() => {}}
          moveNext={() => {}}
          cardClass="card-container"
          customButtonContainerClass="align-btn-left"
          showFooter={true}
          hasSubmitBtn={true}
          formClassNames=""
          buttonState={isloading}
          submitting={submitting}
          btnDisabled={pristine || submitting}
          handleSubmit={handleSubmit(this.onSubmit)}>
        <div className="form-container custom-container">
          <div className="form-row">
            <div className="form-group col-sm-5 col-md-5">
              <Field
                required
                type="text"
                name="name"
                label="Achternaam"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={required}
              />
            </div>
            <div className="form-group col-sm-2 col-md-2 offset-md-1">
              <Field
                type="text"
                name="prefix"
                label="Tussenvoegsel"
                component={InputField}
                props={{formErrors: formErrors}}
              />
            </div>
            <div className="form-group col-sm-6 col-md-3 offset-md-1">
              <Field
                required
                type="text"
                name="first_name"
                label="Voorletters"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={required}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-sm-6 col-md-6">
              <Field
                required
                type="text"
                name="address"
                label="Adres"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={required}
              />
            </div>
            <div className="form-group col-sm-6 col-md-2 offset-md-1">
              <Field
                required
                type="text"
                name="number"
                label="Huisnummer"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={required}
              />
            </div>
            <div className="form-group col-sm-6 col-md-2 offset-md-1">
              <Field
                required
                type="text"
                name="postal_code"
                label="Postcode"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={required}
              />
            </div>
          </div>
          <div className="form-row d-flex justify-content-between">
            <div className="form-group col-sm-6 col-md-3">
              <Field
                required
                type="text"
                name="city"
                label="Plaats"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={required}
              />
            </div>
            <div className="form-group col-sm-6 col-md-3">
              <Field
                required
                type="text"
                name="email"
                label="Email"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={[required, email]}
              />
            </div>
            <div className="form-group col-sm-6 col-md-3">
              <Field
                required
                type="text"
                name="confirm_email"
                label="Bevestig Email"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={[required, email, compare_email]}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group col-sm-6 col-md-6">
              <Field
                required
                type="text"
                name="phone"
                label="Telefoon nummer"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={required}
              />
            </div>
            <div className="form-group col-sm-6 col-md-6">
              <Field
                required
                type="text"
                name="mobile_phone"
                label="Mobiel nummer"
                component={InputField}
                props={{formErrors: formErrors}}
                validate={required}
              />
            </div>
          </div>
          <div className="form-row checkbox-margin-top">
            <div className="form-group col-md-12">
              <Field 
                name="agreement" 
                component={CheckboxField} 
                type="checkbox"
                validate={checked} 
                required
              />
            </div>
          </div>
          {/*<div className="content-footer">
            <button type="submit" className="btn continue-btn mobile-continue-btn" disabled={submitting}>
              {buttonState}
            </button>
          </div>*/}
        </div>
        </PageContent>
      </React.Fragment>
    );
  }
}

StepTwoForm.propTypes = {
  isloading: PropTypes.bool,
  initialValues: PropTypes.object,
  formErrors: PropTypes.object
}

const StepTwoComponent = reduxForm({
  form: 'step-two',
  enableReinitialize: true
})(StepTwoForm);

export default StepTwoComponent;

